export const ClientConfig = (() => {
    switch (window.location.hostname) {
        case 'localhost':
        case '0.0.0.0':
        case 'gp-docker-dashboard.local':
            return {
                SYNCHED_BREAKS_ENABLED: true,
                TIMED_TOURNAMENT_ENABLED: true,
                SPIN_HISTORY_ENABLED: true,
                JSNG_ENTRY_ENABLED: true,
                LEADERBOARD_VISIBILITY_ENABLED: true,
                REDEEMABLE_SWEEPS: {
                    ENABLED: false,
                    POK_USER_IDS: []
                },
                AVATAR_MOVE_ENABLED: true,
                MYSTERY_BOUNTIES_ENABLED: true,
                JSNG_ENTRY_LIABILITY_ENABLED: true,
            };
        case 'dashboard.ci.test.globalpoker.com':
            return {
                SYNCHED_BREAKS_ENABLED: true,
                TIMED_TOURNAMENT_ENABLED: true,
                SPIN_HISTORY_ENABLED: true,
                JSNG_ENTRY_ENABLED: true,
                LEADERBOARD_VISIBILITY_ENABLED: true,
                REDEEMABLE_SWEEPS: {
                    ENABLED: true,
                    POK_USER_IDS: [38086, 90569]
                },
                AVATAR_MOVE_ENABLED: true,
                MYSTERY_BOUNTIES_ENABLED: true,
                JSNG_ENTRY_LIABILITY_ENABLED: true,
            };
        case 'dashboard.qc.test.globalpoker.com':
            return {
                SYNCHED_BREAKS_ENABLED: true,
                TIMED_TOURNAMENT_ENABLED: true,
                SPIN_HISTORY_ENABLED: true,
                JSNG_ENTRY_ENABLED: true,
                LEADERBOARD_VISIBILITY_ENABLED: true,
                REDEEMABLE_SWEEPS: {
                    ENABLED: false,
                    POK_USER_IDS: []
                },
                AVATAR_MOVE_ENABLED: true,
                MYSTERY_BOUNTIES_ENABLED: true,
                JSNG_ENTRY_LIABILITY_ENABLED: true,
            };
        case 'dashboard.globalpoker.com':
            return {
                SYNCHED_BREAKS_ENABLED: true,
                TIMED_TOURNAMENT_ENABLED: true,
                SPIN_HISTORY_ENABLED: true,
                JSNG_ENTRY_ENABLED: true,
                LEADERBOARD_VISIBILITY_ENABLED: true,
                REDEEMABLE_SWEEPS: {
                    ENABLED: false,
                    POK_USER_IDS: []
                },
                AVATAR_MOVE_ENABLED: true,
                MYSTERY_BOUNTIES_ENABLED: true,
                JSNG_ENTRY_LIABILITY_ENABLED: true,
            };
}
    throw new Error('Invalid host configuration, is this a new hostname?');
})();



// WEBPACK FOOTER //
// ./src/app/ClientConfig.ts